import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const TableHeader = ({ columnList }) => (
  <>
    {_.isArray(columnList) ? (
      columnList.map((columnName) => (
        <th
          key={columnName}
          scope="col"
          className="px-2 py-3 text-left text-xs font-bold text-gray-500 tracking-wider"
        >
          {columnName}
        </th>
      ))
    ) : null}
  </>
);

TableHeader.propTypes = {
  columnList: PropTypes.array.isRequired,
};

export default TableHeader;
